export default {
    getSubmittedDocuments: { method: 'get', url: 'api/secure/technical_report/editor/documents' },
    evaluateDocument: { method: 'post', url: 'api/secure/technical_report/document/{pk}/evaluation' },
    getAllProfessors: { method: 'get', url: 'https://intranet.ic.unicamp.br/pub/docentes' }
}